import { computed } from "vue";
import { DraggerType } from "@/drawing";
import DraggerMenuState from "@/stores/DraggerMenuState";
import Settings from "@/stores/Settings";

/**
 * Réduction du panneau de l'outil texte : sur petit écran il masque trop le
 * plan, on le replie en ne gardant que le champ (qui ouvre la saisie), posé en
 * bas à gauche du canvas (TextToolDock).
 *
 * Ne vaut que pour l'outil Texte lui-même : l'écriture manuscrite et le
 * clavier stylet ont besoin du panneau complet (bouton de conversion…), il
 * reparaît donc de lui-même quand on passe sur l'une d'elles.
 */
export function useTextPanelCollapse() {
  const isTextToolActive = computed(
    () => DraggerMenuState.activeDragger.name === DraggerType.Text,
  );

  const isCollapsed = computed(
    () => isTextToolActive.value && Settings.textPanelCollapsed,
  );

  function collapse() {
    Settings.setTextPanelCollapsed(true);
  }

  function expand() {
    Settings.setTextPanelCollapsed(false);
  }

  return { isTextToolActive, isCollapsed, collapse, expand };
}
